import styled from 'styled-components';
import { metrics, colors, fonts } from '@/template/styles';
import Collapse from '@kunukn/react-collapse';

export const Container = styled.div``;

export const BoxForm = styled.div``;

export const CardFilter = styled.div`
    display: flex;
    flex-direction: column;
    gap: 25px; 
    padding: 20px 0;
    width: 100%;

    .filter-grid {
        display: grid;
        grid-template-columns: repeat(8, 1fr);
        gap: 20px;
        align-items: flex-end;
    }

    .col-span-1 { grid-column: span 1; }
    .col-span-2 { grid-column: span 2; }

    .date-section {
        display: contents;
    }

    .date-inputs-container {
        grid-column: span 2;
        display: flex;
        align-items: flex-end;
        width: 100%;
    }

    .date-inputs-container > div {
        flex: 1;
        width: 100%;
    }

    .boxFilter {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 10px;
        min-width: 250px;
    }

    .boxDate {
        display: flex;
        align-items: center;
        gap: 10px;
        position: relative;
        width: 100%;
    }

    .date-picker-container {
        flex: 1;
        min-width: 0;
    }

    .boxSelectOne > *, 
    .boxText > div,
    .boxText input {
        width: 100% !important;
        margin-bottom: 0 !important;
    }

    input, .boxSelectOne > div {
        height: 50px;
    }

    .boxDate input {
        width: 100%;
        height: 50px;
        border: 1px solid #dcdce6;
        border-radius: 5px;
        padding-left: 15px;
    }

    .de {
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        color: #999;
    }
	
    .react-datepicker {
        font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
        font-size: 1.4rem;
        background-color: #fff;
        color: #000;
        border: 1px solid #aeaeae;
        border-radius: 0.3rem;
        display: inline-block;
        position: relative;
    }

    .react-datepicker__day-name,
    .react-datepicker__day,
    .react-datepicker__time-name {
        color: #000;
        display: inline-block;
        width: 3.5rem; 
        line-height: 3.5rem;
        text-align: center;
        margin: 0.166rem;
    }

    .item {
        display: flex;
        align-items: center;
        height: 50px;
        background: ${colors.white};
        border-radius: ${metrics.radius};
        padding: 0 10px;
        border: 2px solid #eee;
        cursor: pointer;
        gap: 8px;
        font-size: 13px;
        justify-content: center;
    }

    .item.active {
        border: 1px solid ${colors.success};
        background: rgba(23, 198, 113, 0.05);
        color: ${colors.success};
        font-weight: 700;
    }

    .actions-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid #eee;
        padding-top: 15px;
    }

    .boxActions {
        display: flex;
        gap: 15px;
    }

    .btn-filter {
        height: 45px;
        padding: 0 25px;
        border-radius: ${metrics.radius};
        font-weight: 700;
        text-transform: uppercase;
        border: none;
        cursor: pointer;
        font-size: 13px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .btn-clear {
        background-color: #f0f0f0 !important;
        color: #666 !important;
        &:hover { background-color: #e5e5e5 !important; }
    }

    .btn-apply {
        background-color: ${colors.success} !important;
        color: white !important;
        &:hover { opacity: 0.9; }
    }

    .boxDate:empty, .boxSelectOne:empty, .boxText:empty {
        display: none;
    }

    .react-datepicker-wrapper {
        width: 100%;
        display: block;
    }

    .react-datepicker__input-container {
        width: 100%;
        display: block;
    }

    .react-datepicker__input-container input {
        width: 100%;
        height: 50px;
        border: 1px solid #dcdce6;
        border-radius: 5px;
        padding-left: 15px;
        box-sizing: border-box;
    }

    .react-datepicker-popper {
        z-index: 10;
        position: absolute !important;
    }

    .btn-clear {
        background-color: #5a8dee !important;
        color: #fff !important;
        
        &:hover {
            background-color: #3965d5 !important;
            box-shadow: 0 4px 8px rgba(90, 141, 238, 0.3);
        }
    }

    .exportExcel {
        display: flex;
        justify-content: flex-end;
    }

    .btn-export {
        height: 45px;
        padding: 0 25px;
        background-color: #1D6F42 !important;
        color: #fff !important;
        border: none;
        border-radius: ${metrics.radius};
        font-weight: 700;
        text-transform: uppercase;
        cursor: pointer;
        transition: all 0.2s;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        font-size: 13px;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
            background-color: #145231 !important;
            transform: translateY(-1px);
            box-shadow: 0 4px 10px rgba(0,0,0,0.2);
        }
    }

    /* Responsividade para largura */
    @media (max-width: 1200px) {
        .filter-grid {
            grid-template-columns: repeat(4, 1fr);
        }
        .col-span-1 { grid-column: span 2; }
    }

    @media (max-width: 768px) {
        .col-span-1, .col-span-2 { grid-column: span 1 !important; }
        .filter-grid {
            grid-template-columns: 1fr;
        }
        .date-section {
            display: flex;
            flex-direction: column;
            gap: 10px;
        }
        .date-inputs-container {
            grid-column: 1 !important;
        }
        
        .actions-container {
            flex-direction: column;
            gap: 15px;
            align-items: stretch;
        }

        .boxActions {
            justify-content: stretch;
        }
        .boxActions > button {
            flex: 1;
        }

        .boxDate {
            flex-direction: column;
            gap: 10px;
        }
        
        .de {
            display: none;
        }
        
        .react-datepicker {
            width: 100%;
            font-size: 1.2rem;
        }
        
        .react-datepicker__day-name,
        .react-datepicker__day,
        .react-datepicker__time-name {
            width: 2.5rem;
            line-height: 2.5rem;
            font-size: 1.2rem;
        }
    }

    @media (max-width: 480px) {
        .react-datepicker__day-name,
        .react-datepicker__day,
        .react-datepicker__time-name {
            width: 2rem;
            line-height: 2rem;
            font-size: 1rem;
        }
    }

    /* Responsividade para altura */
    @media (max-height: 700px) {
        .react-datepicker {
            font-size: 1rem;
        }
        
        .react-datepicker__day-name,
        .react-datepicker__day,
        .react-datepicker__time-name {
            width: 2.5rem;
            line-height: 2.5rem;
            font-size: 1rem;
        }
        
        .react-datepicker__header {
            padding: 6px 0;
        }
        
        .react-datepicker__current-month {
            font-size: 1rem;
            padding: 6px 0;
        }
        
        .react-datepicker__navigation {
            top: 10px;
        }
    }

    @media (max-height: 600px) {
        .react-datepicker__day-name,
        .react-datepicker__day,
        .react-datepicker__time-name {
            width: 2rem;
            line-height: 2rem;
            font-size: 0.9rem;
            margin: 0.1rem;
        }
        
        .react-datepicker__header {
            padding: 4px 0;
        }
        
        .react-datepicker__current-month {
            font-size: 0.9rem;
            padding: 4px 0;
        }
        
        .react-datepicker__navigation {
            top: 8px;
        }
    }

    @media (max-height: 500px) {
        .react-datepicker {
            font-size: 0.8rem;
        }
        
        .react-datepicker__day-name,
        .react-datepicker__day,
        .react-datepicker__time-name {
            width: 1.8rem;
            line-height: 1.8rem;
            font-size: 0.8rem;
        }
        
        .react-datepicker__header {
            padding: 2px 0;
        }
        
        .react-datepicker__current-month {
            font-size: 0.8rem;
            padding: 2px 0;
        }
        
        .react-datepicker__navigation {
            top: 6px;
        }
        
        .react-datepicker__navigation-icon::before {
            height: 5px;
            width: 5px;
        }
    }
`;

export const PaginationContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px; /* Reduzido de 20px para 8px */
    margin-top: 40px;
    padding: 30px 0;
    width: 100%;
    border-top: 1px solid #eee;

    /* Botões de navegação << < > >> */
    .pagination-nav {
        min-width: 40px; /* Reduzido de 130px para 40px */
        height: 40px;
        padding: 0;
        background-color: ${colors.white};
        color: #555;
        border: 1px solid #dcdce6;
        border-radius: 8px; /* Reduzido de 30px para 8px */
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover:not(:disabled) {
            background-color: ${colors.success};
            border-color: ${colors.success};
            color: #fff;
        }

        &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
            background-color: #f5f5f5;
        }
    }

    /* Números das páginas */
    .pagination-numbers {
        display: flex;
        gap: 5px;
        align-items: center;
    }

    .pagination-number {
        min-width: 40px;
        height: 40px;
        background-color: ${colors.white};
        color: #555;
        border: 1px solid #dcdce6;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s ease;

        &:hover:not(.active):not(:disabled) {
            background-color: #f0f0f5;
            border-color: ${colors.success};
            color: ${colors.success};
        }

        &.active {
            background-color: ${colors.success};
            border-color: ${colors.success};
            color: #fff;
        }

        &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }
    }

    @media (max-width: 768px) {
        gap: 5px;
        flex-wrap: wrap;
        
        .pagination-nav,
        .pagination-number {
            min-width: 35px;
            height: 35px;
            font-size: 12px;
        }

        .pagination-numbers {
            order: 3;
            width: 100%;
            justify-content: center;
            margin-top: 10px;
        }
    }
`;

export const ContainerStats = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    margin-bottom: 30px;
    width: 100%;

    @media (max-width: 1100px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 600px) {
        grid-template-columns: 1fr;
    }
`;

export const CardStat = styled.div`
    background: ${colors.white};
    border-radius: ${metrics.radius};
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
    border: 1px solid #f0f0f5;

    .content-left {
        display: flex;
        align-items: center;
        gap: 15px;
    }

    .icon-box {
        width: 45px;
        height: 45px;
        background: #eef5ff; /* Azul clarinho da imagem */
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #5a8dee; /* Azul principal */
    }

    .info {
        display: flex;
        flex-direction: column;

        span {
            font-size: 13px;
            color: #888;
            font-weight: 500;
        }

        strong {
            font-size: 18px;
            color: #444;
            font-weight: 700;
            margin-top: 2px;
        }
    }

    .action-icon {
        color: #ccc;
        cursor: pointer;
        &:hover { color: #888; }
    }
`;

export const ItemSale = styled.div`
    width: 100%;
    background: #fff;
    padding: 2rem;
    border-radius: 5px;
    margin-top: ${metrics.space};
    cursor: pointer;
`;

export const HeaderSales = styled.div`
    width: 100%;

    display: grid;
    grid-template-columns: repeat(9, 1fr) 40px;
    align-items: center;

    div:first-child {
        margin-right: 10px;
    }

    .titulo {
        font-size: ${fonts.smaller};
        color: ${colors.regular};
        font-weight: 700;
        text-transform: uppercase;
    }

    .status-voucher {
        display: flex;
        align-items: center;
    }

    .indicator {
        width: 10px;
        height: 10px;
        border-radius: 10px;
        margin-right: 10px;
    }

    .indicator.success {
        background: ${colors.success};
    }

    .indicator.warning {
        background: ${colors.warning};
    }

    .indicator.danger {
        background: ${colors.danger};
    }
`;

export const ArrowCollapse = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    transform: ${(props) => {
        if (props.open) {
            return `rotate(180deg)`;
        } else {
            return `rotate(0deg)`;
        }
    }};

    transition: all 0.2s;
`;

export const ContainerLoader = styled.div`
    margin-top: ${metrics.space};
`;

export const CollapseItem = styled(Collapse)``;

export const StudentContainer = styled.div`
    .header {
        font-size: ${fonts.small};
        border-bottom: 1px solid ${colors.gray};
        margin-top: ${metrics.space};
        padding-bottom: 1rem;
        font-weight: 700;
    }
    .body {
        display: flex;
        justify-content: space-around;
        margin-top: 1.5rem;
        margin-bottom: 1.5rem;
    }

    .title-item {
        font-size: ${fonts.smaller};
        color: ${colors.regular};
        font-weight: 700;
    }
`;

export const VoucherContainer = styled.div`
    .header {
        font-size: ${fonts.small};
        border-bottom: 1px solid ${colors.gray};
        margin-top: ${metrics.space};
        padding-bottom: 1rem;
        font-weight: 700;
    }
    .body {
        display: flex;
        margin-top: 1.5rem;
        margin-bottom: 1.5rem;
        flex-wrap: wrap;
    }

    .title-item {
        font-size: ${fonts.smaller};
        color: ${colors.regular};
        font-weight: 700;
    }
`;
export const ResponsibleContainer = styled.div`
    .header {
        font-size: ${fonts.small};
        border-bottom: 1px solid ${colors.gray};
        margin-top: ${metrics.space};
        padding-bottom: 1rem;
        font-weight: 700;
    }
    .body {
        display: flex;
        justify-content: space-around;
        margin-top: 1.5rem;
        margin-bottom: 1.5rem;
    }

    .title-item {
        font-size: ${fonts.smaller};
        color: ${colors.regular};
        font-weight: 700;
    }
`;

export const Installments = styled.div`
    .header {
        font-size: ${fonts.small};
        border-bottom: 1px solid ${colors.gray};
        margin-top: ${metrics.space};
        padding-bottom: 1rem;
        font-weight: 700;
        text-transform: uppercase;
    }

    th {
        font-size: ${fonts.smaller};
        padding: 1rem 1rem;
        border-top: 1px solid #e9eaeb;
        border-bottom: 1px solid #e9eaeb;
        text-align: left;
        text-transform: uppercase;
    }

    td {
        border-bottom: 1px solid #d3d3d3;
        padding: 1rem 1rem;
    }
`;

export const Products = styled.div`
    .header {
        font-size: ${fonts.small};
        border-bottom: 1px solid ${colors.gray};
        margin-top: ${metrics.space};
        padding-bottom: 1rem;
        font-weight: 700;
        text-transform: uppercase;
    }

    .box-prod {
        display: flex;
        align-items: center;
    }

    .img-prod {
        width: 50px;
        border-radius: ${metrics.radius};
        margin-right: ${metrics.space};
    }

    th {
        font-size: ${fonts.smaller};
        padding: 1rem 1rem;
        border-top: 1px solid #e9eaeb;
        border-bottom: 1px solid #e9eaeb;
        text-align: left;
        text-transform: uppercase;
    }

    td {
        border-bottom: 1px solid #d3d3d3;
        padding: 1rem 1rem;
    }
`;

export const FooterSale = styled.div`
    display: flex;
    justify-content: space-between;
    background: #1e273b;
    padding: ${metrics.space};
    border-radius: ${metrics.radius};
    color: ${colors.white};

    .title-item {
        font-size: ${fonts.smaller};
        font-weight: 700;
        text-transform: uppercase;
    }

    .total-pago {
        color: ${colors.success};
        font-weight: 700;
    }
`;



